<template>
  <div>
    <h2 class="mt-3">Nhập mã kích hoạt</h2>
    <p class="text-justify">Bằng cách nhập vào mã kích hoạt. Bạn sẽ sở hữu sản phẩm tương ứng với mã kích hoạt.</p>

    <b-alert show="20" v-if="error" variant="danger">
      {{msg}}
    </b-alert>

    <b-form @submit="onSubmit" v-if="show" class="auth__form">
      <b-input-group
        id="input-code"
        label="Mã kích hoạt:"
        label-for="email"
      >
        <b-input-group-append class="auth__form__icon">
          <fa-icon icon="key" />
        </b-input-group-append>
        <b-form-input
          id="makichhoat"
          v-model="makichhoat"
          type="text"
          required
          placeholder="Mã kích hoat của bạn"
          class="auth__form__input"
        ></b-form-input>
      </b-input-group>
      <b-button type="submit" class="auth__form__btn">Xác nhận</b-button>
    </b-form>
  </div>
</template>
<script>
import axios from 'axios'
import { APP_CONFIG } from '@/utils/constants'

export default {
  data() {
    return {
      makichhoat: null,
      show: true,
      error: false,
      msg: null
    }
  },
  watch: {
      makichhoat() {
        this.error = false
      }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault()
        // validate : 
        if(this.makichhoat == null) {
            this.error = true;
        }
        axios.post(`${APP_CONFIG.apiUrl}/ma-kich-hoat`, {
            code: this.makichhoat
        })
        .then(response => {
            this.$router.push(response.data.redirect);
        })
        .catch((err) => {
            this.error = true;
            if (err && err.response && err.response.data) {
                this.msg = err.response.data.message || err.response.data.error || 'Có lỗi xảy ra';
            } else {
                this.msg = (err && err.message) || err || 'Có lỗi xảy ra';
            }
        })
    },
  }
}
</script>